/**
 * Editor Context — provides scene access and graph state to node components.
 * Needed because ReactFlow custom nodes can't receive props directly from the parent.
 */

import React, { createContext, useContext } from 'react';
import type { SceneObject } from 'trace-viewer/scene';
import type { GraphVariable } from 'trace-viewer/behaviors';

export interface EditorContextValue {
    /** The SceneObject that owns the BehaviorGraph behavior */
    contextObject: SceneObject | null;
    /** Graph-scoped variables (for variable picker dropdowns) */
    variables: GraphVariable[];
}

const EditorCtx = createContext<EditorContextValue>({ contextObject: null, variables: [] });

export function EditorContextProvider({
    contextObject,
    variables,
    children,
}: {
    contextObject: SceneObject | null;
    variables: GraphVariable[];
    children: React.ReactNode;
}): React.JSX.Element {
    return (
        <EditorCtx.Provider value={{ contextObject, variables }}>
            {children}
        </EditorCtx.Provider>
    );
}

export function useEditorContext(): EditorContextValue {
    return useContext(EditorCtx);
}
